export const defaultStyles = {
  color: "var(--theme-website-h1-color-text)",
  fontWeight: "var(--theme-website-h1-font-weight)",
  fontSize: "var(--theme-website-h1-font-size)",
  lineHeight: "var(--theme-website-h1-line-height)",
  fontFamily: "var(--theme-website-h1-font-family)",
  textAlign: "left",
  textTransform: "none",
  fontStyle: "normal",
  textDecoration: "none",
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
  padding: {
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "0",
    paddingRight: "0",
  },
} as const;
